import fetch from '../utils/fetch'

export function getMembers (query) {
  return fetch({
    url: '/members',
    method: 'get',
    params: query
  })
}
export function getMember (query) {
  return fetch({
    url: '/member',
    method: 'get',
    params: query
  })
}
/********练习测试**********/

export function getTel (query) {
  return fetch({
    url: '/members/tel',
    method: 'get',
    params: query
  })
}
/*********END***********/
export function setMemberRegisterSetting (query) {
  return fetch({
    url: '/members/register/setting',
    method: 'post',
    data: query
  })
}

export function setMemberRegisterContentSetting (query) {
  return fetch({
    url: '/members/register/setting',
    method: 'post',
    data: query
  })
}


export function getMemberRegisterSetting () {
  return fetch({
    url: '/members/register/setting',
    method: 'get'
  })
}

export function memberSmsSend (query) {
  return fetch({
    url: '/member/smssend',
    method: 'post',
    data: query
  })
}

export function saveTag (query) {
  return fetch({
    url: '/member/tag',
    method: 'post',
    data: query
  })
}

export function getTagList (query) {
  return fetch({
    url: '/member/tag',
    method: 'get',
    params: query
  })
}

export function updateMemberMobile (query) {
  return fetch({
    url: '/member',
    method: 'put',
    params: query
  })
}

export function setMemberSalesman (query) {
  return fetch({
    url: '/member/salesman',
    method: 'put',
    data: query
  })
}

export function updateMemberGrade (query) {
  return fetch({
    url: '/member/grade',
    method: 'put',
    params: query
  })
}

export function batchupdateMemberGrade (query) {
  return fetch({
    url: '/member/grade',
    method: 'patch',
    params: query
  })
}

export function updateMemberInfo (query) {
  return fetch({
    url: '/member',
    method: 'patch',
    params: query
  })
}

export function getMemberOperateLog (query) {
  return fetch({
    url: '/operate/loglist',
    method: 'get',
    params: query
  })
}

export function getTagInfo (tagId) {
  return fetch({
    url: '/member/tag/' + tagId,
    method: 'get'
  })
}

export function updateTag (query) {
  return fetch({
    url: '/member/tag',
    method: 'put',
    data: query
  })
}

export function deleteTag (tagId) {
  return fetch({
    url: '/member/tag/' + tagId,
    method: 'delete'
  })
}

export function usersRelTags (query) {
  return fetch({
    url: '/member/reltag/',
    method: 'post',
    data: query
  })
}

export function tagSearchUser (query) {
  return fetch({
    url: '/member/tagsearch',
    method: 'GET',
    params: query
  })
}

export function listVipGrade (query) {
  return fetch({
    url: '/vipgrade/order',
    method: 'GET',
    params: query
  })
}

export function exportVipGrade(query) {
    return fetch({
        url: '/vipgrade/order/export',
        method:'POST',
        params: query
    })
}

export function sendVipOrderToNp(query) {
    return fetch({
        url:'/vipgrade/order/pushtoNpByAdmin',
        method:'POST',
        params:query
    })
}

export function refundVipOrder(query) {
  return fetch({
      url:'/vipgrade/order/refundVipOrder',
      method:'POST',
      params:query
  })
}

// 告知书列表
export function Inform (query) {
  return fetch({
    url: '/member/inform',
    method: 'GET',
    params: query
  })
}
// 导出全部操作
export function InformPdfs (healthy_id) {
  return fetch({
    url: '/member/pdfs/healthy_id/'+healthy_id,
    method: 'delete'
  })
}
export function memberExport(query) {
  return fetch({
    url: '/member/export',
    method: 'GET',
    params: query
  })
}
export function randomlist(query) {
  return fetch({
    url: '/kaquanrandom/getrandomlist',
    method: 'GET',
    params: query
  })
}
export function buildrandom(query) {
  return fetch({
    url: '/kaquanrandom/buildrandom',
    method: 'post',
    data: query
  })
}
//开卡
export function delKaika (kaikaId) {
  return fetch({
    url: '/member/kaika/' + kaikaId,
    method: 'delete'
  })
}
export function saveKaika (query) {
  return fetch({
    url: '/member/kaika',
    method: 'post',
    data: query
  })
}
export function getKaikaList (query) {
  return fetch({
    url: '/member/kaika',
    method: 'get',
    params: query
  })
}
export function updateKaika (query) {
  return fetch({
    url: '/member/kaika',
    method: 'put',
    data: query
  })
}
// 同步异常线下卡
export function updateMemberOffline (query) {
  return fetch({
    url: '/member/synchOfflineCard',
    method: 'put',
    data: query
  })
}
export function kaikaExport (query) {
  return fetch({
    url: '/member/kaikaExport',
    method: 'get',
    params: query
  })
}
/**
 * E卡通类型
 */
export function getEcardTypeList(query) {
  return fetch({
    url: '/members/yikangcardtype',
})
}
//卡池列表
export function getcardPoolist (query) {
  return fetch({
    url: '/member/cardpool',
    method: 'get',
    params: query
  })
}
export function createEcardType(data) {
  return fetch({
    url: '/members/yikangcardtype',
    method: 'post',
    data: data
  })
}

export function updateEcardType (id,data) {
  return fetch({
    url: '/members/yikangcardtype/'+id,
    method: 'put',
    data: data
  })
}

export function deleteEcardType (id) {
  return fetch({
    url: '/members/yikangcardtype/'+id,
    method: 'delete',
  })
}
/**
 * E卡通
 */
export function getEcardList (query) {
  return fetch({
    url: '/members/yikangcardcard',
    method: 'get',
    params: query
  })
}


export function ecardExport (query) {
  return fetch({
    url: '/members/yikangcardcard/export',
    method: 'get',
    params: query
  })
}

export function createEcard (data) {
  return fetch({
    url: '/members/createCard',
    method: 'post',
    data: data
  })
}

export function changeCardPlayStatus (data) {
  return fetch({
    url: '/members/changeCardPlayStatus',
    method: 'post',
    data: data
  })
}

export function ecardlogExport (query) {
  return fetch({
    url: '/members/yikangcardmemberlog/export',
    method: 'get',
    params: query
  })
}

export function advancelogExport (query) {
  return fetch({
    url: '/members/memberadvance/export',
    method: 'post',
    data: query
  })
}


export function resetMemberPassword (query) {
  return fetch({
    url: '/members/shopRestPassword',
    method: 'post',
    data: query
  })
}

export function pushMemberCenter (query) {
  return fetch({
    url: '/members/pushMemberCenter',
    method: 'post',
    data: query
  })
}

export function batchDelUserInfo (query) {
  return fetch({
    url: '/members/del/wxapp/info',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/member.js